import { useEffect } from 'react';
import { useAppSelector } from '~/hooks/useAppSelector';
import { Center, Row, Text } from '../../../../commonComponents';
import browserHistory from '../../../../history';
import activeStep from '../../../../images/progressBarMDB/activeStep.svg';
import firstStep from '../../../../images/progressBarMDB/greenSolidCircle.svg';
import inactiveStep from '../../../../images/progressBarMDB/inactiveStep.svg';
import { Colors } from '../../../../themes/colors';

interface IStepProps {
  title: string;
  active: boolean;
  isFirstStep?: boolean;
}

const Step = ({ title, active, isFirstStep = false }: IStepProps) => (
  <Row
    style={{
      alignItems: 'center',
    }}
  >
    {isFirstStep && <img src={firstStep} alt={title} />}
    {!isFirstStep && active && <img src={activeStep} alt={title} />}
    {!isFirstStep && !active && <img src={inactiveStep} alt={title} />}
    <Text color={active ? Colors.neutral_600 : Colors.neutral_300} marginLeft={4}>
      {title}
    </Text>
  </Row>
);

interface IProgressBarProps {
  step: number;
  title?: string;
  isHidden?: boolean;
}

/**
 * @deprecated ProgressBar is deprecated. Please use the Stepper component instead.
 * The Stepper component provides better functionality and follows current design patterns.
 */
export const ProgressBar = ({
  step,
  title = 'Professional Request / Re-Book',
  isHidden = false,
}: IProgressBarProps) => {
  const jobDates = useAppSelector((state) => state.multiday.jobDates);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (jobDates === null && step > 1) {
      browserHistory.replace('/dashboard/multi-day/info');
    }
  }, [step, jobDates]);

  return (
    <Center marginBottom={32}>
      <Text bold fontSize={32} textAlign="center">
        {title}
      </Text>

      {!isHidden && (
        <Row
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            height: 30,
            gap: '4px',
            marginTop: 24,
          }}
        >
          <Step title="Shift Details" active isFirstStep />
          <Step title="Review and Confirm" active={step >= 2} />
        </Row>
      )}
    </Center>
  );
};
